import _ from 'lodash'
import type { BeckyFunctionLibrary, BeckyModel, BeckyRequestPayload, RefBeckyModel } from '@wix/thunderbolt-becky-root'
import type { Data, Structure } from '@wix/thunderbolt-becky-types'
import { createRemoteRefsFetcher, resolveByRef } from '@wix/thunderbolt-byref'

const hasUnresolvedByRefComp = (structure: Structure) =>
	_(structure)
		.values()
		.filter((comp) => !!comp.componentType && comp.componentType.endsWith('RefComponent'))
		.map('components')
		.some(_.isEmpty)

export const resolveByRefComponents = (
	beckyModel: BeckyModel,
	masterPageStructure: Structure,
	masterPageData: Data,
	functionLibrary: BeckyFunctionLibrary,
	requestPayload: BeckyRequestPayload
) =>
	functionLibrary.runAsyncAndReport(async () => {
		const resolveGhosts = requestPayload.resolveGhosts === 'true'

		const fetchRemoteRefs = createRemoteRefsFetcher(
			functionLibrary.fetchUrl.bind(functionLibrary),
			beckyModel.clientSpecMap,
			beckyModel.publicTopology,
			requestPayload
		)

		const resolveByRefIfNeeded = async (model: RefBeckyModel) => {
			if (!hasUnresolvedByRefComp(model.structure)) {
				return model
			}

			const widgetTemplatesStore = await fetchRemoteRefs(model.data.document_data)

			const res = resolveByRef({ ...model, widgetTemplatesStore })

			return { ...model, ...res }
		}

		return beckyModel.pageCompId === 'masterPage'
			? resolveByRefIfNeeded({
					...beckyModel,
					structure: masterPageStructure,
					data: masterPageData,
					masterPageStructure,
					masterPageData,
					requestPayload,
					resolveGhosts,
					widgetTemplatesStore: { mobile: {}, desktop: {} },
			  })
			: resolveByRefIfNeeded({
					...beckyModel,
					masterPageStructure,
					masterPageData,
					requestPayload,
					resolveGhosts,
					widgetTemplatesStore: { mobile: {}, desktop: {} },
			  })
	}, 'tb-byRef-resolving')
